import React from 'react'
import {Page} from './'

export default () => (
    <Page title="Privacy">
        <p>
            We consider that by using the « Le BrandCenter » you shall provide us only with professional information
            related to the e-learning services you are provided you with within the fulfilment of your contractual
            obligations towards RICHARD MILLE Group.
        </p>
        <p>
            Nevertheless, in the improbable case you would provide us with personal information, you shall know that we
            respect the confidentiality of any such information. Consequently, the same personal data policy that
            applies to the www.richardmille.com Website shall also apply to the “Le BrandCenter” users and covers the
            processing of personal data you may provide us with in order to allow us to offer you the required
            e-learning services and features.
        </p>
        <p>
            The personal data processing is carried out in France at Paris by R.D.M.M. Concepts (RICHARD MILLE France)
            and in Switzerland at Les Breuleux by Horométrie S.A. a company of the RICHARD MILLE Group. The RICHARD
            MILLE’s data processing policy is described hereunder.
        </p>
        <p>
            By providing us with personal data according to that data processing policy, you express your acceptance of
            it and your consent to the data processing it describes.
        </p>
        <p>
            User data will be collected during user visits and according to his/her interaction with the services and
            features offered on the Website. At any time, the user may exercise his/her rights in compliance with the
            law.
        </p>
        <h2>Data use and transfer</h2>
        <p>
            The personal data you provide us with, for example in an order or by email (for example, your name and
            address or email address), are processed solely for correspondence with you and solely for the purpose for
            which you have provided these data, which is managing contractual relations with you and fulfil relevant
            legal obligations.
        </p>
        <p>
            We hereby confirm that we will not pass on your personal data to other third parties excepted for their
            processing in Les Breuleux Switzerland by Horométrie S.A. a company of RICHARD MILLE Group, unless we are
            legally required to do so or you have previously given us your express permission. To the extent that we
            make use of service companies to carry out and process administrative tasks, contractual relations are
            regulated in compliance with the provisions of EU’s Data Protection Law.
        </p>
        <p>
            R.D.M.M. Concepts (RICHARD MILLE France) is the data controller and the data processing respondent according
            to GDPR.
        </p>
        <h2>Consent and revocation</h2>
        <p>
            By providing us with personal data, you express your acceptance to their aforementioned processing.
        </p>
        <p>
            If you have provided us with personal data, you may revoke your consent, and can modify and/or delete them
            at any time, by writing to privacy@richardmille.com or by post to 45 Rue Boissy d’Anglas, 75008 Paris,
            France.
        </p>
        <h2>Storage period</h2>
        <p>
            Personal data conveyed to us through our website are stored only until the purpose for which they were
            conveyed is fulfilled and for the length of time needed to achieve it. Data collected for contract
            management will be retained for the time period necessary for the performance of the contract, with legal
            and conventional guarantees provided for, or in accordance with obligatory legal terms regarding the
            retention of data. If storage periods are stipulated by trade law or tax law, a secured storage of
            particular data can last up to 10 years.
        </p>
        <h2>Data security</h2>
        <p>
            In the ordering process, your personal data are transmitted by means of SSL via the Internet. We carry out
            technical and organizational measures to secure our website and other storage systems to prevent loss,
            destruction, access, or change to your data by unauthorized persons.
        </p>
        <h2>Use of cookies</h2>
        <p>
            We use cookies on various pages to make a visit to our website more attractive and to enable the use of
            certain functions. Cookies are small text files deposited on your computer. Most of the cookies we use are
            deleted from your hard disk after the end of a browser session (“session cookies”). Other cookies may remain
            on your computer and enable us to recognize your computer when you next visit our website (“permanent
            cookies”). Our partner companies are not permitted to use our cookies and our website to gather, process, or
            use personal data.
        </p>
        <h2>Your rights, information</h2>
        <p>
            If you no longer agree to the storage of your personal data or if these data are no longer correct, upon
            receiving your corresponding request we will have your data deleted or blocked or carry out the necessary
            corrections (to the extent that this is permissible under valid law). Upon request and at no charge, we will
            inform you about all personal data about you that we have stored.
        </p>
        <p>
            If you have questions about the gathering, processing, or use of your personal data or if you want to
            provide information or corrections or to block or delete data, please contact us by email at
            privacy@richardmille.com
        </p>
        <h2>Google Analytics</h2>
        <p>
            This website uses Google Analytics, a web analysis service provided by Google Inc., 1600 Amphitheatre
            Parkway, Mountain View, CA 94043, USA (“Google”).
        </p>
        <p>
            Google Analytics uses so-called “cookies“, text files that are stored on your computer and allow an analysis
            to be performed of your Richard Mille’s website usage. The information generated by the cookie about your
            usage of this website (including your IP address), is transferred to a Google server in the US and stored
            there. Google uses the stored information to evaluate your usage of Richard Mille’s website, to compile
            reports about activities performed on this website for the website operator and in order to provide further
            services related to said website and internet usage.
        </p>
        <p>
            Google also transfers this information to third parties when necessary, for example if it is legally
            required or in the case that third parties are commissioned by Google to process this data. Google never
            links your IP address to other Google data. You can prevent installation of the cookies by adjusting an
            appropriate setting in your browser software; however, we would like to advise you that you may not be able
            to use all functions of this website to their full extent in this case. By using this website, you agree for
            the data recorded on you by Google in the aforementioned manner to be processed and agree to the
            aforementioned purpose.
        </p>
        <p>
            You can stop your data from being collected in future at any time by using the desactivation addon for
            Google Analytics browsers at http://tools.google.com/dlpage/gaoptout?hl=en. You can also prevent your data
            being recorded by Google Universal Analytics by clicking on the following link:
            https://tools.google.com/dlpage/gaoptout/eula.html?hl=en. An opt-out cookie will be set, which prevents your
            data from being recorded in future when you visit Richard Mille’s website: Desactivate Google Analytics. We
            would like to advise you that this website uses Google Analytics with the extension “_anonymizeIp()”. This
            means IP addresses are only stored in an anonymous form; any direct reference to a specific person in
            relation to the stored data is therefore excluded. Third parties, including Google, use the stored cookies
            to place advertisements not related to Richard Mille’s products on the basis of your previous visits to
            Richard Mille’s website. If you do not wish for this to happen, you can deactivate this via the ad settings
            manager http://www.google.com/settings/ads/onweb/?hl=en&.
        </p>
        <p>
            For more detailed information on user conditions and data protection, please visit
            http://www.google.com/analytics/terms/us.html.
        </p>
    </Page>
)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Privacy.js